import React, { ReactNode } from 'react';

type Props = DeepReadonly<{
  children: ReactNode;
}>;

export const TableBody: React.FC<Props> = ({ children }: Props) => (
  <tbody>{children}</tbody>
);
